import "./about.css";
import me from "./../../img/kr.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img src={me} alt="" className="a-img" />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Us</h1>
        {/* <p className="a-desc">
          -- Sweven offers a range of different flavours to ensure that you are
          offered variety and enjoyment while drinking tea. 
        </p> */}
               <p className="a-desc">
          -- We are offering the most competitive price on the market.
        </p>
        {/* <p className="a-desc">
          -- A hasle free travel.
        </p> */}
        <p className="a-desc">
          -- You only need to pay one price because our fair already includes all applicable toll and road charges.
        </p>
        <p className="a-desc">
          -- Drivers are very courteous, and cars should be well-kept and maintained.
        </p>
        {/* <p className="a-desc">
          -- Less expensive than other options for more distance or time.
        </p> */}
        <p className="a-desc">
          -- We offer a 24/7 service.
        </p>
        {/* <p className="a-desc">
          -- Taste the warmth and homely Indian atmosphere in every sip of the sweven black tea at your morning breakfast routine.
        </p>
        <p className="a-desc">
          -- The unique taste is a favourite among tea lovers for its classic aroma and exotic pecks that are sure to revitalize you with every sip.
        </p> */}
        <h1 className="a-title">Our Categories</h1>
        <p className="a-desc">
          -- Hatchback : WagonR, Alto, Swift, Eon,etc.
        </p>
        <p className="a-desc">
          -- Sedan : Swift Dzire, Aura, Xcent, Amaze, Etios,etc.
        </p>
        <p className="a-desc">
          -- SUV : Xylo, Ertiga, Innova, Crysta etc.
        </p>
        {/* <p className="a-desc">
          -- Assured Innova : Innova, Crysta,etc.
        </p> */}
        
        <p className="a-desc">
          -- Mini Bus : Traveller.
        </p>
        
          {/* <p className="a-desc">
          --  Aids in Digestion.
        </p> */}
        
          {/* <p className="a-desc">
          -- Helps in weight loss.
        </p> */}
  
        {/* <p className="a-desc">
          --  All the toll taxes & road tax already include in our fair you just pay the one amount.
        </p>
          <p className="a-desc">
          -- Drivers are very polite in behaviour.
        </p>
        <p className="a-desc">
          -- Less charges as compare to other for extra distance or time.
        </p>
      
        <p className="a-desc">
          -- All cars should be clean and good in maintainence.
        </p> */}
        {/* <h1 className="a-title1">
          Referred by: <br />
          Mr. Sagnik Bose <br />
          CEO & Founder of Preneurship
        </h1> */}
        {/* <p className="a-desc">
          His exposure in this area is very good. During his job,he easily
          handled major responsibilties and
          <br /> we found him hardworking and very productive to us. He is dedicated &
          self-started who <br />
          is motivated,duly bound and a highly committed team player with strong
          analytical knowledge.
        </p> */}
      </div>
    </div>
  );
};

export default About;
